import Toastr from "../../itrust_common/components/Toastr"
const DEFAULT_STATE = {
  notes: [],
  saving: false
}
let changes = null;

export default function notesReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let notes = [];
  let noteData = [];
  let updatedRecord = {};

  switch (action.type) {
    case 'NOTES_LOAD_PENDING':
      return { ...state, saving: true };

    case 'NOTES_CREATE_PENDING':
    case 'NOTES_UPDATE_PENDING':
      return { ...state, saving: true };

    case 'NOTES_LOAD_REJECTED':
    case 'NOTES_CREATE_REJECTED':
    case 'NOTES_UPDATE_REJECTED':
    case 'NOTES_DELETE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case 'NOTES_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false
      };
      return { ...state, ...changes };

    case 'NOTES_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      notes = [...state.notes]
      let newRecord = response.note
      changes = {
        notes: [...notes, newRecord],
        editing: false,
        saving: false
      }
      return { ...state, ...changes };

    case 'NOTES_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      notes = [...state.notes];
      updatedRecord = response.note;
      for (const [index, note] of notes.entries()) {
        if (note.id === updatedRecord.id) {
          noteData = [
            ...notes.slice(0, index),
            updatedRecord,
            ...notes.slice(index + 1)
          ];
        }
      }
      changes = {
        notes: noteData,
        editing: false,
        saving: false
      };
      return { ...state, ...changes };

    case 'NOTES_DELETE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      notes = [...state.notes];
      for (const [index, note] of notes.entries()) {
        if (note.id === response.note.id) {
          notes.splice(index, 1);
        }
      }
      return {
        ...state,
        notes: notes,
        error: null
      };

    default:
      return state;
  }
}